import React from "react";
import { Helmet } from "react-helmet-async";
import Navbar from "../Components/Navbar/Navbar";
import ProductCard from "../Components/ProductCard/ProductCard";
import Footer from "../Components/Footer/Footer";
import { Box } from "@mui/material";
import CardImg from "../Assets/vegan_soft_mung_bean.png";
import useMetaTracking from "../hooks/useMetaTracking";

function VeganSoftMungBeanBun() {
  useMetaTracking("ViewContent", {
    content_name: "Vegan Soft Mung Bean Bun",
    content_category: "Vegan Menu",
    content_ids: ["vegan_soft_mung_bean_bun"],
    content_type: "vegan_vietnamese_pastries",
    value: 4.00,
    currency: "USD",
  });

  return (
    <>
      <Helmet>
        <title>Vegan Soft Mung Bean Bun | Đông Hưng Viên Bakery</title>
        <meta
          name="description"
          content="Filled with silky mung bean paste that's lightly sweet and gently starchy, similar to a softer, less sweet sweet potato, these vegan mini buns offer a clean, comforting bite."
        />
        <meta
          property="og:title"
          content="Vegan Soft Mung Bean Bun | Đông Hưng Viên Bakery"
        />
        <meta
          property="og:description"
          content="Filled with silky mung bean paste that's lightly sweet and gently starchy, similar to a softer, less sweet sweet potato, these vegan mini buns offer a clean, comforting bite."
        />
      </Helmet>
      <Box className="product-page" sx={{ pt: 10, background: "#0f0f0f" }}>
        <Navbar />
        <ProductCard
          cardImg={CardImg}
          titleHead="VEGAN SOFT MUNG BEAN BUN"
          titleSubHead="$4.00 each"
          detailBody="Filled with silky mung bean paste that's lightly sweet and gently starchy, similar to a softer, less sweet sweet potato, these vegan mini buns offer a clean, comforting bite."
          detailBodyBr="Contains: wheat"
          detailBody3="Vegan"
          ProductCardBtn="View Full Vegan Menu"
          btnLink="/vegan-menu"
        />
        <Footer />
      </Box>
    </>
  );
}

export default VeganSoftMungBeanBun;